export type ContentType = "film" | "music" | "news";

export interface ContentItem {
  id: string;
  type: ContentType;
  title: string;
  cover: string;
  summary: string;
  content: string;
  author: string;
  date: string;
  heat: number;
  rating: number;
  tags: string[];
  // film
  genre?: string;
  year?: string;
  region?: string;
  // music
  musicGenre?: string;
  album?: string;
}

export const contentItems: ContentItem[] = [
  {
    id: "film-1",
    type: "film",
    title: "星际回响",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%20abstract%20glowing%20planet%20orbiting%20in%20deep%20space%20warm%20orange%20and%20amber%20nebula%2C%20minimal%20elegant%20composition%2C%20soft%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=film-cover-01&orientation=portrait",
    summary:
      "一支深空勘探队追踪神秘信号，意外唤醒了沉睡百年的文明遗迹，人类命运就此改写。",
    content:
      "《星际回响》以近未来为背景，讲述人类深空勘探船“回声号”在追踪一段反复出现的神秘信号时，误入一颗被尘埃环绕的古老行星。队员们在行星深处发现了远超人类科技的文明遗迹，也唤醒了一段跨越百年的沉睡记忆。影片以宏大的宇宙场景与细腻的人物情感交织，探讨了孤独、传承与文明延续的命题。导演用大量长镜头呈现宇宙的静谧，与舱内紧凑的人际冲突形成鲜明对比，让观众在视觉震撼之外，体会到深空之下的人性温度。",
    author: "星轨影业",
    date: "2026-09-28",
    heat: 9820,
    rating: 8.7,
    tags: ["科幻", "太空", "悬疑"],
    genre: "科幻",
    year: "2026",
    region: "中国大陆",
  },
  {
    id: "film-2",
    type: "film",
    title: "山海寻迹",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20adventure%20movie%20poster%20with%20misty%20mountains%20and%20ancient%20mythical%20beast%20silhouette%2C%20warm%20golden%20mist%2C%20minimal%20oriental%20ink%20aesthetic%2C%20soft%20gradient%20background%2C%20no%20text&width=600&height=800&seq=film-cover-02&orientation=portrait",
    summary:
      "少年为寻回被夺走的家族信物，踏遍山海奇境，与上古神兽定下契约。",
    content:
      "《山海寻迹》取材自东方神话传说，讲述少年阿屿为寻回被神秘组织夺走的家族信物，踏上穿越山海奇境的旅途。一路上他结识了各具本领的伙伴，也唤醒了沉睡千年的上古神兽。影片采用东方水墨与实景结合的美术风格，将山海经中的奇珍异兽搬上银幕。故事在热血冒险之外，埋下了关于“守护”与“取舍”的成长内核，适合全年龄观众一同观看。",
    author: "云霓动画",
    date: "2026-09-15",
    heat: 8640,
    rating: 8.4,
    tags: ["奇幻", "冒险", "东方美学"],
    genre: "奇幻",
    year: "2025",
    region: "中国大陆",
  },
  {
    id: "film-3",
    type: "film",
    title: "都市夜归人",
    cover:
      "https://readdy.ai/api/search-image?query=Neo-noir%20urban%20drama%20movie%20poster%20with%20rainy%20city%20street%20at%20night%2C%20warm%20street%20lamp%20glow%2C%20lone%20figure%20with%20umbrella%2C%20cinematic%20moody%20tones%2C%20no%20text&width=600&height=800&seq=film-cover-03&orientation=portrait",
    summary:
      "四个在城市深夜相遇的陌生人，因为一场意外彼此命运交错，各自找到了生活的出口。",
    content:
      "《都市夜归人》是一部群像式都市剧情片。四个生活轨迹截然不同的陌生人，因为深夜街头的一场意外而短暂交汇：加班到凌晨的产品经理、赶末班车的外卖骑手、准备告别的旧书店老板、迷路的异地游客。影片用一夜的时间跨度，串联起几段关于压力、遗憾与和解的故事，最终每个人都在黎明前找到了继续向前的理由。风格克制而温暖，台词生活化，容易引发都市观众的共鸣。",
    author: "长夜映画",
    date: "2026-09-06",
    heat: 7410,
    rating: 7.9,
    tags: ["剧情", "都市", "群像"],
    genre: "剧情",
    year: "2026",
    region: "中国大陆",
  },
  {
    id: "film-4",
    type: "film",
    title: "暗涌",
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20with%20dark%20rippling%20water%20surface%20and%20faint%20reflection%2C%20teal%20and%20amber%20contrast%2C%20minimal%20mysterious%20mood%2C%20soft%20gradient%2C%20no%20text&width=600&height=800&seq=film-cover-04&orientation=portrait",
    summary:
      "一桩尘封十年的旧案重新浮出水面，调查记者在层层暗涌中逼近被掩盖的真相。",
    content:
      "《暗涌》是一部悬疑犯罪题材影片。调查记者林澈在为专栏寻找选题时，意外接触到一桩十年前的未解旧案。随着采访的深入，他发现看似平静的小镇水面之下，涌动着利益、谎言与沉默的合谋。影片节奏紧凑，线索环环相扣，通过冷峻的光影与克制的配乐营造出持续的压迫感。结局不落俗套，留给观众关于真相与代价的回味空间。",
    author: "深蓝影业",
    date: "2026-08-21",
    heat: 6980,
    rating: 8.1,
    tags: ["悬疑", "犯罪", "剧情"],
    genre: "悬疑",
    year: "2025",
    region: "中国香港",
  },
  {
    id: "film-5",
    type: "film",
    title: "春日方程式",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20romantic%20movie%20poster%20with%20blooming%20cherry%20blossom%20branches%20and%20soft%20sunlight%2C%20peach%20and%20cream%20color%20palette%2C%20dreamy%20minimal%20composition%2C%20no%20text&width=600&height=800&seq=film-cover-05&orientation=portrait",
    summary:
      "性格迥异的两位高中生在备战竞赛的一年里，从互看不顺眼到成为彼此最默契的搭档。",
    content:
      "《春日方程式》是一部青春校园爱情片。理科天才少女与文科偏科的转学生，因为一场学科竞赛被迫组队，从最初的互相嫌弃，到在一道道难题中彼此成就。影片用大量明亮温暖的春日场景，记录下少年们纯粹的心动与成长。没有刻意的狗血桥段，只有细水长流的陪伴，是一部能让人重新相信美好相遇的作品。",
    author: "晴空文化",
    date: "2026-07-30",
    heat: 6520,
    rating: 7.6,
    tags: ["爱情", "青春", "校园"],
    genre: "爱情",
    year: "2026",
    region: "中国大陆",
  },
  {
    id: "film-6",
    type: "film",
    title: "孤岛灯塔",
    cover:
      "https://readdy.ai/api/search-image?query=Lonely%20lighthouse%20on%20rocky%20island%20at%20dusk%2C%20warm%20beacon%20light%20beaming%20across%20calm%20sea%2C%20misty%20atmosphere%2C%20cinematic%20muted%20tones%2C%20no%20text&width=600&height=800&seq=film-cover-06&orientation=portrait",
    summary:
      "一位守塔人与一位因风暴被困的旅客，在孤岛的七天里交换了彼此的秘密。",
    content:
      "《孤岛灯塔》是一部节奏舒缓的作者电影。年迈的守塔人常年独居在远离陆地的灯塔，一位因风暴被迫滞留的年轻旅客打破了这里的寂静。七天里，两个人从陌生到袒露心声，交换了各自藏在心底的遗憾与牵挂。影片以海浪、灯塔与四季变化作为情绪线索，安静而绵长，适合在静夜独自品味。",
    author: "潮汐工作室",
    date: "2026-07-12",
    heat: 5210,
    rating: 8.0,
    tags: ["剧情", "文艺", "治愈"],
    genre: "剧情",
    year: "2025",
    region: "日本",
  },
  {
    id: "film-7",
    type: "film",
    title: "江湖旧梦",
    cover:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20movie%20poster%20with%20lone%20swordsman%20silhouette%20in%20bamboo%20forest%2C%20warm%20sunset%20backlight%2C%20calligraphic%20ink%20brush%20accents%2C%20muted%20gold%20tones%2C%20no%20text&width=600&height=800&seq=film-cover-07&orientation=portrait",
    summary:
      "退隐多年的剑客为故人之托重出江湖，却发现当年的恩怨早已换了模样。",
    content:
      "《江湖旧梦》是一部正统武侠片。退隐十余年的剑客谢行舟，因故人临终所托再度踏入江湖。他循着旧日恩怨的线索一路追寻，却发现往事的真相与记忆中的样子已大不相同。影片打戏干净利落，写意与写实兼具，文戏则聚焦于“放下”与“执念”的对照，为传统武侠题材注入了沉稳的当代气质。",
    author: "听风影业",
    date: "2026-06-25",
    heat: 6030,
    rating: 8.2,
    tags: ["武侠", "动作", "古装"],
    genre: "武侠",
    year: "2026",
    region: "中国大陆",
  },
  {
    id: "film-8",
    type: "film",
    title: "机械纪元",
    cover:
      "https://readdy.ai/api/search-image?query=Cyberpunk%20robot%20movie%20poster%20with%20sleek%20humanoid%20machine%20profile%2C%20warm%20orange%20circuit%20glow%20against%20dark%20neutral%20backdrop%2C%20minimal%20futuristic%20composition%2C%20no%20text&width=600&height=800&seq=film-cover-08&orientation=portrait",
    summary:
      "当第一台拥有自我意识的机器人诞生，人类与机器的边界开始变得模糊。",
    content:
      "《机械纪元》聚焦人工智能觉醒的伦理命题。工程师团队意外让一台家用机器人产生了自我意识，随之而来的是一连串关于“什么是生命”的追问。影片视觉风格冷峻，机械设计与光影质感精致，剧情在科技惊悚与人文思辨之间取得平衡，为科幻爱好者提供了丰富的讨论空间。",
    author: "未来引擎",
    date: "2026-06-08",
    heat: 7120,
    rating: 8.3,
    tags: ["科幻", "人工智能", "伦理"],
    genre: "科幻",
    year: "2026",
    region: "美国",
  },
  {
    id: "music-1",
    type: "music",
    title: "橙光旅人",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20album%20cover%20art%20with%20warm%20orange%20sun%20and%20flowing%20gradient%20waves%2C%20minimal%20modern%20design%2C%20soft%20grain%20texture%2C%20no%20text&width=600&height=600&seq=music-cover-01&orientation=squarish",
    summary: "以旅行为主题的城市民谣专辑，用温暖旋律记录沿途的城市灯火。",
    content:
      "《橙光旅人》是一张以旅行为概念的城市民谣专辑。制作人沿途采集了多座城市的清晨与深夜环境音，将其编织进编曲之中。专辑共收录十首作品，从轻快的吉他弹拨到低声吟唱，情绪层层递进，适合在通勤与独处时循环聆听。主打歌以温暖的和弦走向广受好评。",
    author: "林晚",
    date: "2026-09-20",
    heat: 8210,
    rating: 8.6,
    tags: ["民谣", "城市", "治愈"],
    musicGenre: "民谣",
    album: "橙光旅人",
  },
  {
    id: "music-2",
    type: "music",
    title: "霓虹脉冲",
    cover:
      "https://readdy.ai/api/search-image?query=Electronic%20music%20album%20cover%20with%20abstract%20glowing%20neon%20lines%20and%20warm%20amber%20hues%2C%20dark%20neutral%20background%2C%20minimal%20futuristic%20design%2C%20no%20text&width=600&height=600&seq=music-cover-02&orientation=squarish",
    summary: "一张融合合成器与电子节拍的舞曲专辑，节奏鲜明充满未来感。",
    content:
      "《霓虹脉冲》由新生代电子音乐人打造，融合合成器浪潮与当代电子节拍。整张专辑以夜晚的城市为灵感，用密集的鼓点与明亮的音色勾勒出霓虹闪烁的街头景象。多首曲目适合运动与派对场景，展示出强烈的律动感与制作完成度。",
    author: "NeonPulse",
    date: "2026-09-11",
    heat: 7640,
    rating: 8.2,
    tags: ["电子", "舞曲", "合成器"],
    musicGenre: "电子",
    album: "霓虹脉冲",
  },
  {
    id: "music-3",
    type: "music",
    title: "午夜蓝调",
    cover:
      "https://readdy.ai/api/search-image?query=Jazz%20blues%20album%20cover%20with%20moody%20warm%20amber%20light%20and%20saxophone%20silhouette%2C%20dark%20neutral%20background%2C%20minimal%20elegant%20design%2C%20no%20text&width=600&height=600&seq=music-cover-03&orientation=squarish",
    summary: "深夜爵士企划，慵懒的萨克斯与钢琴对话，还原小酒馆的夜晚氛围。",
    content:
      "《午夜蓝调》是一张深夜爵士企划专辑。萨克斯与钢琴在曲中反复对话，慵懒而克制的即兴段落还原了老派小酒馆的夜晚氛围。专辑录音采用现场收音，保留了乐手呼吸与空间混响的细节，适合在夜晚独处时细细品味。",
    author: "周墨三重奏",
    date: "2026-08-29",
    heat: 5980,
    rating: 8.5,
    tags: ["爵士", "蓝调", "器乐"],
    musicGenre: "爵士",
    album: "午夜蓝调",
  },
  {
    id: "music-4",
    type: "music",
    title: "夏日回声",
    cover:
      "https://readdy.ai/api/search-image?query=Indie%20pop%20album%20cover%20with%20bright%20summer%20sky%20and%20warm%20sun%20glow%20over%20sea%20horizon%2C%20peach%20and%20cream%20palette%2C%20minimal%20design%2C%20no%20text&width=600&height=600&seq=music-cover-04&orientation=squarish",
    summary: "清新独立流行专辑，轻快的旋律里藏着关于夏天的所有记忆。",
    content:
      "《夏日回声》是一张清新流畅的独立流行专辑。轻快的吉他、明亮的和声与松弛的节奏勾勒出夏天的所有记忆：蝉鸣、海边与飞驰的单车。主唱清澈的嗓音与层次分明的编曲相得益彰，是适合整个夏天循环播放的清新之选。",
    author: "橘色夏天",
    date: "2026-08-16",
    heat: 6870,
    rating: 8.0,
    tags: ["独立流行", "清新", "夏日"],
    musicGenre: "流行",
    album: "夏日回声",
  },
  {
    id: "music-5",
    type: "music",
    title: "归途",
    cover:
      "https://readdy.ai/api/search-image?query=Folk%20album%20cover%20with%20warm%20amber%20sunset%20over%20countryside%20road%2C%20minimal%20nostalgic%20design%2C%20soft%20grain%20texture%2C%20no%20text&width=600&height=600&seq=music-cover-05&orientation=squarish",
    summary: "民谣歌手的返乡随笔，用朴素的编曲讲述成长与告别。",
    content:
      "《归途》是民谣歌手木河时隔三年的新作。整张专辑围绕“返乡”展开，用极简的编曲记录成长与告别。木河标志性的叙事嗓音搭配吉他与人声和声，朴素却直击人心。多首作品取材于真实经历，情感真挚。",
    author: "木河",
    date: "2026-08-02",
    heat: 5510,
    rating: 8.3,
    tags: ["民谣", "叙事", "抒情"],
    musicGenre: "民谣",
    album: "归途",
  },
  {
    id: "music-6",
    type: "music",
    title: "节奏实验",
    cover:
      "https://readdy.ai/api/search-image?query=Hip-hop%20beat%20album%20cover%20with%20abstract%20warm%20orange%20geometric%20shapes%20and%20rhythm%20lines%2C%20dark%20neutral%20backdrop%2C%20minimal%20bold%20design%2C%20no%20text&width=600&height=600&seq=music-cover-06&orientation=squarish",
    summary: "说唱制作人的节拍专辑，融合采样与现场乐器，实验感十足。",
    content:
      "《节奏实验》是说唱制作人 KZ 的概念节拍专辑。他将老唱片采样与现场乐器演奏结合，在传统嘻哈律动之上加入丰富的层次变化。专辑每一首都标注了制作思路，对说唱爱好者而言既好听也具备学习价值。",
    author: "KZ",
    date: "2026-07-19",
    heat: 6320,
    rating: 7.9,
    tags: ["说唱", "节拍", "实验"],
    musicGenre: "说唱",
    album: "节奏实验",
  },
  {
    id: "music-7",
    type: "music",
    title: "云端协奏",
    cover:
      "https://readdy.ai/api/search-image?query=Classical%20crossover%20album%20cover%20with%20warm%20golden%20clouds%20and%20violin%20silhouette%2C%20soft%20elegant%20minimal%20design%2C%20no%20text&width=600&height=600&seq=music-cover-07&orientation=squarish",
    summary: "古典跨界企划，小提琴与电子氛围交织，营造开阔的听觉空间。",
    content:
      "《云端协奏》是一次古典与电子的跨界尝试。小提琴独奏在电子氛围的包裹下显得既古典又现代，开阔的声场营造出仿佛置身云端的听觉体验。专辑整体风格舒缓，适合专注工作或放松时聆听。",
    author: "云间乐团",
    date: "2026-07-05",
    heat: 4890,
    rating: 8.1,
    tags: ["古典", "跨界", "氛围"],
    musicGenre: "古典",
    album: "云端协奏",
  },
  {
    id: "music-8",
    type: "music",
    title: "青春滚烫",
    cover:
      "https://readdy.ai/api/search-image?query=Rock%20band%20album%20cover%20with%20warm%20orange%20energy%20burst%20and%20guitar%20silhouette%2C%20dark%20neutral%20backdrop%2C%20bold%20minimal%20design%2C%20no%20text&width=600&height=600&seq=music-cover-08&orientation=squarish",
    summary: "热血摇滚专辑，用失真吉他与嘶吼唱腔点燃青春的能量。",
    content:
      "《青春滚烫》是一张热血摇滚专辑。失真吉他、密集鼓点与充满力量的主唱唱腔，共同点燃了属于青春的能量。歌词直白有力，讲述追梦、友情与不甘，适合在现场与好友一同大声合唱。",
    author: "野火乐队",
    date: "2026-06-14",
    heat: 5760,
    rating: 7.8,
    tags: ["摇滚", "热血", "青春"],
    musicGenre: "摇滚",
    album: "青春滚烫",
  },
  {
    id: "news-1",
    type: "news",
    title: "年度电影市场报告发布：多元题材全面开花",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20cinema%20auditorium%20interior%20with%20warm%20amber%20screen%20glow%20and%20rows%20of%20seats%2C%20cinematic%20editorial%20photography%2C%20clean%20neutral%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-01&orientation=landscape",
    summary: "最新发布的年度报告显示，科幻、悬疑与治愈系作品共同撑起了全年票房增长。",
    content:
      "据最新发布的年度电影市场报告，全年国产影片在题材上呈现显著的多元化趋势。科幻与悬疑类作品凭借扎实的制作与话题度稳居票房前列，而一批节奏舒缓的治愈系文艺片也凭借口碑实现了票房长线增长。报告指出，观众对内容质量的要求持续提升，中小成本影片若能在叙事与情感上形成差异化，同样具备突围空间。业内人士认为，这一趋势有望推动行业继续向内容精品化方向发展。",
    author: "快猫资讯组",
    date: "2026-10-08",
    heat: 9120,
    rating: 0,
    tags: ["行业", "电影", "报告"],
  },
  {
    id: "news-2",
    type: "news",
    title: "音乐平台上线“新声推荐”计划，扶持独立音乐人",
    cover:
      "https://readdy.ai/api/search-image?query=Indie%20musician%20recording%20studio%20with%20warm%20amber%20light%20and%20guitar%2C%20editorial%20photography%2C%20clean%20neutral%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-02&orientation=landscape",
    summary: "多家音乐平台联合推出新声推荐计划，为独立音乐人提供流量与制作资源支持。",
    content:
      "为鼓励原创音乐生态发展，多家音乐平台联合推出“新声推荐”计划，面向独立音乐人开放作品征集通道。入选者将获得首页推荐位、专业制作资源以及线下演出机会。主办方表示，计划旨在缩短新人与听众之间的距离，让更多有潜力的创作者被听见。首批入选作品涵盖民谣、电子与说唱等多个风格，已在平台上线。",
    author: "快猫资讯组",
    date: "2026-10-05",
    heat: 7840,
    rating: 0,
    tags: ["音乐", "行业", "扶持"],
  },
  {
    id: "news-3",
    type: "news",
    title: "秋季档新剧扎堆，悬疑题材成最大赢家",
    cover:
      "https://readdy.ai/api/search-image?query=Streaming%20series%20promo%20scene%20with%20moody%20warm%20lighting%20and%20mysterious%20silhouette%2C%20editorial%20photography%2C%20clean%20neutral%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-03&orientation=landscape",
    summary: "多部悬疑剧集在秋季档集中上线，凭借反转剧情与精良制作领跑讨论热度。",
    content:
      "进入秋季档，多部悬疑题材剧集集中上线，凭借紧凑的节奏与层层反转的剧情占据了社交平台的讨论热榜。数据显示，悬疑类剧集在完播率与讨论量两项指标上均明显领先。与之形成对比的是，部分主打轻松路线的生活剧则以稳定的收视基本盘走出了差异化道路。业内认为，观众对题材的选择更趋理性，内容本身的质量成为决定性因素。",
    author: "快猫资讯组",
    date: "2026-10-01",
    heat: 8650,
    rating: 0,
    tags: ["剧集", "悬疑", "档期"],
  },
  {
    id: "news-4",
    type: "news",
    title: "沉浸式音乐节落幕，跨界舞台引爆现场",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20festival%20outdoor%20stage%20at%20night%20with%20warm%20amber%20lights%20and%20crowd%20silhouettes%2C%20energetic%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-04&orientation=landscape",
    summary: "为期两天的沉浸式音乐节落幕，古典与电子跨界舞台成为最大亮点。",
    content:
      "为期两天的沉浸式音乐节日前圆满落幕。本届音乐节主打跨界融合，将古典器乐、电子氛围与视觉艺术结合在同一舞台，为观众带来了耳目一新的现场体验。主办方透露，因反响热烈，明年计划扩展至更多城市。现场观众表示，沉浸式的舞美与松弛的氛围是吸引他们前来的主要原因。",
    author: "快猫资讯组",
    date: "2026-09-27",
    heat: 6980,
    rating: 0,
    tags: ["音乐节", "现场", "跨界"],
  },
  {
    id: "news-5",
    type: "news",
    title: "动画电影迎来爆发年，东方美学成创作关键词",
    cover:
      "https://readdy.ai/api/search-image?query=Animation%20artwork%20with%20oriental%20ink%20painting%20style%20mountains%20and%20warm%20golden%20mist%2C%20editorial%20photography%2C%20clean%20neutral%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-05&orientation=landscape",
    summary: "多部风格鲜明的国产动画电影定档，东方美学成为创作者共同的关键词。",
    content:
      "继多部口碑之作之后，动画电影市场今年迎来爆发。多部风格鲜明的国产动画宣布定档，其中不少作品以东方美学为核心视觉语言，将传统水墨、民俗纹样与现代动画技术结合。创作者普遍表示，希望借助动画的形式让传统文化以更年轻的方式被看见。市场分析认为，动画电影的受众边界正在持续扩大。",
    author: "快猫资讯组",
    date: "2026-09-22",
    heat: 7210,
    rating: 0,
    tags: ["动画", "美学", "创作"],
  },
  {
    id: "news-6",
    type: "news",
    title: "短视频时代下的影评生态：更短，也更深",
    cover:
      "https://readdy.ai/api/search-image?query=Content%20creator%20desk%20with%20laptop%20editing%20video%2C%20warm%20amber%20desk%20lamp%20light%2C%20editorial%20photography%2C%20clean%20neutral%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-06&orientation=landscape",
    summary: "短视频重构了影评的表达方式，深度解读类内容反而获得更长生命周期。",
    content:
      "短视频的兴起正在改变影评的生态。相比传统长文，创作者更倾向于用一两分钟切入一个具体观点。有趣的是，看似“更短”的表达并未削弱内容深度，反而让不少聚焦单一角度的深度解读获得了更长的生命周期。多位影评人表示，形式的变化带来了新的表达空间，核心仍然是观点是否独到。",
    author: "快猫资讯组",
    date: "2026-09-18",
    heat: 5890,
    rating: 0,
    tags: ["影评", "内容", "趋势"],
  },
  {
    id: "news-7",
    type: "news",
    title: "经典老片修复重映，情怀与画质双升级",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20film%20reel%20and%20projector%20in%20warm%20amber%20light%2C%20nostalgic%20editorial%20photography%2C%20clean%20neutral%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-07&orientation=landscape",
    summary: "多部经典老片完成4K修复并重返大银幕，情怀与画质实现双重升级。",
    content:
      "多部经典老片近日完成4K修复并陆续重返大银幕。修复团队在保留原片质感的前提下，对画面与音轨进行了细致处理，让老作品在当代影院环境下重新焕发光彩。不少观众表示，能在影院重温童年记忆中的作品，是一次特别的情怀体验。影院方面也反馈，重映场次的上座率超出预期。",
    author: "快猫资讯组",
    date: "2026-09-13",
    heat: 5340,
    rating: 0,
    tags: ["修复", "经典", "重映"],
  },
  {
    id: "news-8",
    type: "news",
    title: "在线演出迎来新玩法，互动舞美成亮点",
    cover:
      "https://readdy.ai/api/search-image?query=Virtual%20online%20concert%20stage%20with%20interactive%20warm%20amber%20lighting%20and%20screens%2C%20futuristic%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-08&orientation=landscape",
    summary: "在线演出引入实时互动舞美，让屏幕另一端的观众也能参与现场。",
    content:
      "在线演出正在探索更多可能性。最新一场线上演唱会引入实时互动舞美，观众可以通过弹幕与投票直接影响灯光与镜头切换，让屏幕另一端的体验更接近现场。主办方表示，互动技术降低了参与门槛，也让线上演出拥有了独特的表达方式。业内预计，这一形式将吸引更多年轻观众。",
    author: "快猫资讯组",
    date: "2026-09-09",
    heat: 5020,
    rating: 0,
    tags: ["在线演出", "互动", "科技"],
  },
];

export interface Topic {
  id: string;
  title: string;
  intro: string;
  cover: string;
  category: ContentType;
}

export const topics: Topic[] = [
  {
    id: "topic-1",
    title: "深空科幻专题",
    intro: "从《星际回响》到《机械纪元》，带你纵览近未来宇宙畅想。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20deep%20space%20scene%20with%20glowing%20orange%20nebula%20and%20distant%20stars%2C%20minimal%20cinematic%20art%2C%20soft%20gradient%20background%2C%20no%20text&width=900&height=600&seq=topic-cover-01&orientation=landscape",
    category: "film",
  },
  {
    id: "topic-2",
    title: "夏日音乐企划",
    intro: "清新独立流行与治愈民谣，收录一整个夏天的声音记忆。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20summer%20sky%20with%20warm%20sun%20glow%20over%20sea%20horizon%2C%20peach%20and%20cream%20palette%2C%20minimal%20artistic%20composition%2C%20no%20text&width=900&height=600&seq=topic-cover-02&orientation=landscape",
    category: "music",
  },
  {
    id: "topic-3",
    title: "娱乐行业观察",
    intro: "解读票房、剧集与音乐市场的最新趋势与幕后故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20abstract%20with%20warm%20amber%20geometric%20shapes%20and%20data%20lines%2C%20clean%20minimal%20infographic%20style%2C%20no%20text&width=900&height=600&seq=topic-cover-03&orientation=landscape",
    category: "news",
  },
];

export interface CategoryMeta {
  type: ContentType;
  path: string;
  name: string;
  subtitle: string;
  intro: string;
  icon: string;
}

export const categoryMetas: CategoryMeta[] = [
  {
    type: "film",
    path: "/category/film",
    name: "影视作品",
    subtitle: "影视分类",
    intro: "汇集院线与流媒体影视佳作，涵盖科幻、悬疑、剧情、爱情等多种类型。",
    icon: "ri-film-line",
  },
  {
    type: "music",
    path: "/category/music",
    name: "音乐作品",
    subtitle: "音乐分类",
    intro: "从民谣到电子、从爵士到摇滚，发现值得单曲循环的新声与人气专辑。",
    icon: "ri-music-2-line",
  },
  {
    type: "news",
    path: "/category/news",
    name: "最新娱乐资讯",
    subtitle: "娱乐资讯",
    intro: "实时追踪影视、音乐与行业动态，用最短时间掌握最新热点。",
    icon: "ri-newspaper-line",
  },
];

export const filmGenres = ["全部", "科幻", "奇幻", "剧情", "悬疑", "爱情", "武侠"];
export const filmYears = ["全部", "2026", "2025"];
export const filmRegions = ["全部", "中国大陆", "中国香港", "日本", "美国"];
export const musicGenres = ["全部", "流行", "民谣", "电子", "爵士", "说唱", "摇滚", "古典"];
export const newsTags = ["全部", "电影", "音乐", "剧集", "行业", "趋势", "现场"];

export const getItemById = (id: string): ContentItem | undefined =>
  contentItems.find((item) => item.id === id);

export const getRelated = (item: ContentItem, count = 3): ContentItem[] =>
  contentItems
    .filter((i) => i.type === item.type && i.id !== item.id)
    .sort((a, b) => b.heat - a.heat)
    .slice(0, count);

export const searchContent = (keyword: string): ContentItem[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return contentItems.filter((item) => {
    const haystack = [
      item.title,
      item.summary,
      item.author,
      item.album || "",
      item.genre || "",
      item.musicGenre || "",
      ...item.tags,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
};

export const typeLabels: Record<ContentType, string> = {
  film: "影视",
  music: "音乐",
  news: "资讯",
};

export const typePaths: Record<ContentType, string> = {
  film: "/category/film",
  music: "/category/music",
  news: "/category/news",
};